export default __webpack_public_path__ + "static/media/logo-alt.b342a59a.ico";